import { getCookieValue } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'
import { fetchPendingAssignments, fetchUnacceptedAssignments } from './fetchAssignmentListsActions'

export const acceptOrReassignAssignment = (propertyAppraisalId, lin, assignmentAccepted, reassignmentReason) => {
  return (dispatch) => {
    fetch(`/lgyhub/api/appraiser-workspace/property-appraisal/${propertyAppraisalId}/${assignmentAccepted ? 'accept' : 'reassign'}`, {
      credentials: 'include',
      method: 'PATCH',
      body: JSON.stringify({
        noteAccess: 'INTERNAL',
        noteType: 'APPRAISER_REASSIGNMENT',
        note: reassignmentReason
      }),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      const errorText = assignmentAccepted ? `acknowledging receipt of assignment ${lin}` : `requesting reassignment for ${lin}`
      return catchCommonErrors(dispatch, response, errorText)
    }).then(() => {
      dispatch(fetchPendingAssignments())
      dispatch(fetchUnacceptedAssignments())
    }).catch((error) => {
      console.error('Error accepting or reassigning assignment: ', error)
    })
  }
}

export default acceptOrReassignAssignment
